import request from "./request";

const DocumentService = {
    GetAll: async (searchText, context, signal) => {
        return await request.sendRequest(`/document/all/search/${searchText}`, context.token, signal);
    },
    GetDashboard: async (context, signal) => {
        return await request.sendRequest(`/document/dashboard`, context.token, signal);
    },
    GetCourseDashboard: async (context, signal) => {
        return await request.sendRequest(`/document/dashboard/courses`, context.token, signal);
    },
    GetAllByType: async (type, searchText, context) => {
        return await request.sendRequest(`/document/all/${type}/${searchText}`, context.token);
    },
    GetAllByTagType: async (tag, type, searchText, context) => {
        return await request.sendRequest(`/document/all/${tag}/${type}/${searchText}`, context.token);
    },
    GetAllByTags: async (payload, searchText, context) => {
        return await request.sendPostRequest(`/document/tags/${searchText}`, payload, context);
    },
    GetAllByTagTypes: async (tag, payload, searchText, context) => {
        return await request.sendPostRequest(`/document/types/${tag}/${searchText}`, payload, context);
    },
    GetDocuments: async (context, signal) => {
        return await request.sendRequest(`/document/list/documents`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/document/${id}`, context.token, signal);
    },
    GetFile: async (id, context, signal) => {
        return await request.sendRequest(`/document/file/${id}`, context.token, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendFormDataRequest(`/document`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/document/${id}`, context.token);
    },
    RemoveDocument: async (id, context) => {
        return await request.sendDeleteRequest(`/document/file/${id}`, context.token);
    },
};

export default DocumentService;
